export default {
	OPERATION_EXPANDED: 'OPERATION_EXPANDED',
	OPERATION_COLLAPSED: 'OPERATION_COLLAPSED',
};
